import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // автоматически определит язык браузера (можно отключить)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        translation: require('./locales/ru/translation.json')
      },
      ua: {
        translation: require('./locales/ua/translation.json')
      }
    },
    fallbackLng: 'ua',     // если язык не найден
    debug: false,
    interpolation: {
      escapeValue: false, // React уже экранирует
    },
    detection: {
      // Отключаем автоопределение, чтобы язык брался только из наших настроек
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage'], // сохраняем выбранный язык
    }
  });

export default i18n;